const eventDetails = {
  historical: [45, 35, 63, 53],
  underlyings: [
    {
      name: 'Coffee',
      chg: -2.5,
      products: [
        'WisdomTree Coffee 3x Daily Leveraged',
        'WisdomTree Coffee 6x Daily Leveraged',
        'WisdomTree Coffee 9x Daily Leveraged',
      ],
    },
    {
      name: 'Wheat',
      chg: 1.5,
      products: [
        'WisdomTree Wheat 3x Daily Leveraged',
        'WisdomTree Wheat 6x Daily Leveraged',
        'WisdomTree Wheat 9x Daily Leveraged',
      ],
    },
  ],
};

export default eventDetails;
